<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>함께하는 분들</h3>
            </div>
            <h4>패널 업체</h4>
            <div class="company-wrap">
                <div class="logo3"><a href="https://www.samsungdisplay.com/kor/index.jsp" target="_blank"><img src="/src/assets/images/ci/samsungdisplay.png" alt="삼성디스플레이" /></a></div>
                <div class="logo4"><a href="https://www.lgdisplay.com/kor" target="_blank"><img src="/src/assets/images/ci/lgdisplay.png" alt="LG디스플레이" /></a></div>
            </div>
            <h4>설계 업체</h4>
            <div class="company-wrap">
                <div><a href="https://www.kornic.co.kr/kr/" target="_blank"><img src="/src/assets/images/ci/kornic.png" alt="코닉오토메이션" /></a></div>
            </div>
            <h4>소자 업체</h4>
            <div class="company-wrap">
              <div><a href="https://www.dongjin.com/main/" target="_blank"><img src="/src/assets/images/ci/dongjin.png" alt="동진쎄미켐" /></a></div>
              <div><a href="https://www.seoulviosys.com/kr" target="_blank"><img src="/src/assets/images/ci/seoulviosys.png" alt="서울바이오시스" /></a></div>
            </div>
            <h4>장비 업체</h4>
            <div class="company-wrap">
              <div><a href="https://www.apsystems.co.kr/" target="_blank"><img src="/src/assets/images/ci/apsystems.png" alt="AP 시스템" /></a></div>
            </div>
            <h4>대학교</h4>
            <div class="company-wrap">
              <div><a href="https://www.skku.edu/skku/index.do" target="_blank"><img src="/src/assets/images/ci/skku.png" alt="성균관대학교" /></a></div>
              <div><a href="https://www.yonsei.ac.kr/sc/index.do" target="_blank"><img src="/src/assets/images/ci/yonsei.png" alt="연세대학교" /></a></div>
              <div><a href="https://www.sch.ac.kr/" target="_blank"><img src="/src/assets/images/ci/sch.png" alt="순천향대학교" /></a></div>
            </div>
            <h4>정부/전문기관</h4>
            <div class="company-wrap">
              <div><a href="https://www.motie.go.kr/" target="_blank"><img src="/src/assets/images/ci/motie.png" alt="산업부" /></a></div>
              <div><a href="https://www.kiat.or.kr/front/user/main.do" target="_blank"><img src="/src/assets/images/ci/kiat.png" alt="KIAT" /></a></div>
              <div><a href="https://www.keti.re.kr/main/main.php" target="_blank"><img src="/src/assets/images/ci/keti.png" alt="한국전자기술연구원" /></a></div>
            </div>
            <h4>공동연구개발기관</h4>
            <div class="company-wrap">
              <div><a href="https://www.hanyang.ac.kr/web/www/erica-campus1" target="_blank"><img src="/src/assets/images/ci/hanyang.png" alt="한양대학교 에리카" /></a></div>
              <div><a href="https://www.ctp.or.kr/main.do" target="_blank"><img src="/src/assets/images/ci/ctp.png" alt="충남 테크노파크" /></a></div>
            </div>
            <h4>기타</h4>
            <div class="company-wrap">
              <div><a href="https://looksten.com/" target="_blank"><img src="/src/assets/images/ci/looksten.png" alt="룩슨" /></a></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    h4 {
        @include font-size_xl;
        margin: 24px 0 16px;
        &:first-of-type {
            margin-top: 0;
        }
    }

</style>
<script setup>
</script>